import React from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { TargetAudience } from './components/TargetAudience';
import { SystemOverview } from './components/SystemOverview';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { Pricing } from './components/Pricing';
import { TotalPackDetails } from './components/TotalPackDetails';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
import { PurchaseNotification } from './components/PurchaseNotification';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-brand-black text-white font-sans selection:bg-brand-pink selection:text-white pb-20 md:pb-0" data-id="element-0">
      <Hero data-id="element-1" />
      <Testimonials data-id="element-2" />
      <PainPoints data-id="element-3" />
      <TargetAudience data-id="element-4" />
      <SystemOverview data-id="element-5" />
      <Modules data-id="element-6" />
      <Bonuses data-id="element-7" />
      <Comparison data-id="element-8" />
      {/* First Pricing block with Scarcity */}
      <Pricing data-id="element-9" />
      <TotalPackDetails data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      <Footer data-id="element-13" />
      <StickyCTA data-id="element-14" />
      <PurchaseNotification data-id="element-15" />
      <MetaPixel data-id="element-16" />
    </div>;
}